export class Capability {
  capability: string;
  description: string;
}
